import { Base } from '../../../../../common/models';
import { TransportListFiltersDatepickerRangeModel } from './transport-list-filters.model';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';

export class TransportCatalogSearchCriteria extends TransportListFiltersDatepickerRangeModel {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  id?: number;
  name?: string;
  constructor(params?: TransportCatalogSearchCriteria | Base) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
